module.exports = __webpack_public_path__ + "img/30a38af.png";